module.exports = __webpack_public_path__ + "static/img/icon4.7bad037.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/icon4.png
// module id = Hfab
// module chunks = 3